import * as React from 'react';

import classnames from 'classnames';

import {EditableLabel} from 'shells/editable-label/editable-label';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

import type {Lead as LeadFragment} from 'nutshell-graphql-types';

import styles from './lead-header-left.module.css';

type Props = {
    lead: LeadFragment;
    onUpdateLeadName: (arg1: string) => Promise<any>;
};

export function LeadNameContainer(props: Props) {
    const {lead, onUpdateLeadName} = props;

    return (
        <div
            id='lead-name'
            className={classnames(
                'popover-opener-south',
                lead.deletedTime ? styles['name-container--deleted'] : styles['name-container']
            )}
        >
            <EditableLabel
                value={lead.name}
                onSaveNewValue={onUpdateLeadName}
                placeholder='Unnamed lead'
                allowSavingEmpty={true}
                shouldTruncate={true}
            />
            {lead.deletedTime ? (
                <span className={styles['deleted-text']}>
                    Deleted&nbsp;
                    <RelativeTimestamp datetime={lead.deletedTime} />
                </span>
            ) : undefined}
        </div>
    );
}
